import Vue from "vue";
import VueRouter from "vue-router";
import index from "../views/index.vue";
import products from "../views/products.vue";
import contact from "../views/contact.vue";
import registry from "../views/registry.vue";
import support from "../views/support.vue";
import cooperation from "../views/cooperation.vue";
import introduction from "../views/introduction.vue";
import CamoDetail from  "../views/products/camodetail.vue";
import CamoDeviceDetail from "../views/products/camodevicedetail.vue";
import CamoChairDetail from "../views/products/camochairdetail.vue";
import TrainingSystemS3 from "../views/products/trainingsystem_s3.vue";
import TrainingSystemS2 from "../views/products/trainingsystem_s2.vue";
import TrainingSystemS1 from "../views/products/trainingsystem_s1.vue";
import TrainingSystemS4 from "../views/products/trainingsystem_s4.vue";
import TrainingSystemS5 from "../views/products/trainingsystem_s5.vue";
import ChairZhenXin from "../views/products/chair_zhenxin.vue";
import ChairAi from "../views/products/chair_ai.vue";
import ChairKunPeng from "../views/products/chair_kunpeng";
import ChairJiZhi from "../views/products/chair_jizhi.vue"
import DeviceS1 from "../views/products/device_s1.vue";
import DeviceS2 from "../views/products/device_s2.vue";
import DeviceS3 from "../views/products/device_s3.vue";
import DeviceS4 from "../views/products/device_s4.vue";
import Sand15 from  "../views/products/sand_15.vue";
import Sand11 from "../views/products/sand_11.vue";
import Sand8 from "../views/products/sand_8.vue";
import VrV1 from "../views/products/vr_v1.vue";
import VrV2 from "../views/products/vr_v2.vue";
import Mirror from "../views/products/mirror.vue";
import NeckMassage from "../views/products/neck_massage.vue";
import EyeMassage from "../views/products/eye_massage.vue";
import EyeProMassage from "../views/products/eye_pro_massage.vue";
import FasciaMassage from "../views/products/fascia_massage.vue";
import userAgreement from "../views/other/Agreement";
import privacyPolicy from "../views/other/privacyPolicy";

// 报错解决
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push;

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace;

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
	return originalReplace.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "index",
		component: index,
		meta: {
			title: "首页",
		},
	},
	{
		path: "/products",
		name: "products",
		component: products,
		meta: {
			title: "产品中心",
		},
	},
	{
		path: "/camo_detail",
		name: "CamoDetail",
		component: CamoDetail,
		meta: {
			title: "迷彩高端定制",
		},
	},
	{
		path: "/camo_device_detail",
		name: "CamoDeviceDetail",
		component: CamoDeviceDetail,
		meta: {
			title: "迷彩训练设备",
		},
	},
	{
		path: "/camo_chair_detail",
		name: "CamoChairDetail",
		component: CamoChairDetail,
		meta: {
			title: "迷彩按摩椅",
		},
	},
	{
		path: "/training_system_s3",
		name: "TrainingSystemS3",
		component: TrainingSystemS3,
		meta: {
			title: "心理压力评测训练系统(HY-S3)",
		},
	},
	{
		path: "/training_system_s2",
		name: "TrainingSystemS2",
		component: TrainingSystemS2,
		meta: {
			title: "心理压力评测训练系统(HY-S2)",
		},
	},
	{
		path: "/training_system_s1",
		name: "TrainingSystemS1",
		component: TrainingSystemS1,
		meta: {
			title: "心理压力评测训练系统(HY-S1)",
		},
	},
	{
		path: "/training_system_s4",
		name: "TrainingSystemS4",
		component: TrainingSystemS4,
		meta: {
			title: "心理压力评测训练系统(HY-S4)",
		},
	},
	{
		path: "/training_system_s5",
		name: "TrainingSystemS5",
		component: TrainingSystemS5,
		meta: {
			title: "心理压力评测训练系统(HY-S5)",
		},
	},
	{
		path: "/chair_zhenxin",
		name: "ChairZhenXin",
		component: ChairZhenXin,
		meta: {
			title: "臻芯椅",
		},
	},
	{
		path: "/chair_ai",
		name: "ChairAi",
		component: ChairAi,
		meta: {
			title: "AI经络椅",
		},
	},
	{
		path: "/chair_kunpeng",
		name: "ChairKunPeng",
		component: ChairKunPeng,
		meta: {
			title: "鲲鹏椅",
		},
	},
	{
		path: "/chair_jizhi",
		name: "ChairJiZhi",
		component: ChairJiZhi,
		meta: {
			title: "极智椅",
		},
	},
	{
		path: "/device_s1",
		name: "DeviceS1",
		component: DeviceS1,
		meta: {
			title: "心理压力评测训练系统(HY-S1)设备",
		},
	},
	{
		path: "/device_s2",
		name: "DeviceS2",
		component: DeviceS2,
		meta: {
			title: "心理压力评测训练系统(HY-S2)设备",
		},
	},
	{
		path: "/device_s3",
		name: "DeviceS3",
		component: DeviceS3,
		meta: {
			title: "心理压力评测训练系统(HY-S3)设备",
		},
	},
	{
		path: "/device_s4",
		name: "DeviceS4",
		component: DeviceS4,
		meta: {
			title: "心理压力评测训练系统(HY-S4)设备",
		},
	},
	{
		path: "/sand_15",
		name: "Sand15",
		component: Sand15,
		meta: {
			title: "沙画机 HY-Z1型 15寸",
		},
	},
	{
		path: "/sand_11",
		name: "Sand11",
		component: Sand11,
		meta: {
			title: "沙画机 HY-Z1型 11寸",
		},
	},
	{
		path: "/sand_8",
		name: "Sand8",
		component: Sand8,
		meta: {
			title: "沙画机 HY-Z1型 8寸",
		},
	},
	{
		path: "/vr_hy_v1",
		name: "VrV1",
		component: VrV1,
		meta: {
			title: "智能VR心理疏导系统 HY-V1型",
		},
	},
	{
		path: "/vr_hy_v2",
		name: "VrV2",
		component: VrV2,
		meta: {
			title: "智能VR心理疏导系统 HY-V2型",
		},
	},
	{
		path: "/mirror_detail",
		name: "Mirror",
		component: Mirror,
		meta: {
			title: "专业智能力量健身镜商务版",
		},
	},
	{
		path: "/neck_massage",
		name: "NeckMassage",
		component: NeckMassage,
		meta: {
			title: "智能减压颈部按摩",
		},
	},
	{
		path: "/eye_massage",
		name: "EyeMassage",
		component: EyeMassage,
		meta: {
			title: "眼部按摩仪",
		},
	},
	{
		path: "/eye_pro_massage",
		name: "EyeProMassage",
		component: EyeProMassage,
		meta: {
			title: "眼部按摩仪PRO",
		},
	},
	{
		path: "/fascia_massage",
		name: "FasciaMassage",
		component: FasciaMassage,
		meta: {
			title: "筋膜枪-摩力小拳王",
		},
	},
	{
		path: "/cooperation",
		name: "cooperation",
		component: cooperation,
		meta: {
			title: "商务合作",
		},
	},
	{
		path: "/support",
		name: "support",
		component: support,
		meta: {
			title: "服务支持",
		},
	},
	{
		path: "/registry",
		name: "registry",
		component: registry,
		meta: {
			title: "服务注册",
		},
	},
	{
		path: "/introduction",
		name: "introduction",
		component: introduction,
		meta: {
			title: "公司介绍",
		},
	},
	{
		path: "/contact",
		name: "contact",
		component: contact,
		meta: {
			title: "联系我们",
		},
	},
	{
		path: "/user_agreement",
		name: "userAgreement",
		component: userAgreement,
		meta: {
			title: "APP用户协议",
		},
	},
	{
		path: "/privacy_policy",
		name: "privacyPolicy",
		component: privacyPolicy,
		meta: {
			title: "隐私政策",
		},
	}
];
// title

const router = new VueRouter({
	//文件夹名称可自己随意设置,需要与后续tomcat下webapps里面新建的那个文件夹名字保持一致
	//base: '/huiyun/',
	routes,
	// 跳转页面后 回到顶部
	scrollBehavior() {
		return {
			x: 0,
			y: 0,
		};
	},
});

export default router;

// title
const defaultTitle = "默认 title";
router.beforeEach((to, from, next) => {
	document.title = to.meta.title ? to.meta.title : defaultTitle;
	next();
});
